import { useEffect } from 'react';

import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { appLinks, appPages } from 'routes/routes';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { getBackgrounds, miscApiUrl } from 'api/miscApi';
import useSWR from 'swr';
import { useAppContext } from 'store';
import { setBackgrounds } from 'store/actions';

const Layout: React.FC = (): JSX.Element => {
  const location = useLocation();
  const { setDocumentTitle } = useDocumentTitle();
  const { data: backgrounds } = useSWR(miscApiUrl.getBackgrounds, getBackgrounds);
  const navigate = useNavigate();
  const {
    state: { isAuth },
    dispatch,
  } = useAppContext();

  useEffect(() => {
    if (location.pathname == appLinks.home.link) {
      if (isAuth) {
        navigate(appLinks.tvGuide.link);
      } else {
        navigate(appLinks.loginWithQR.link);
      }
    }
  }, [isAuth, location.pathname, navigate]);

  useEffect(() => {
    backgrounds && dispatch(setBackgrounds(backgrounds));
  }, [dispatch, backgrounds]);

  // set document title
  useEffect(() => {
    const path = appPages.find((link) => link.link === location.pathname);
    if (!path) return;
    setDocumentTitle(path?.name);
  }, [location, setDocumentTitle]);

  return <Outlet />;
};

export default Layout;
